import UA from "ua-device";

function generateUUID() {
  var d = new Date().getTime();
  var uuid = "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function(
    c
  ) {
    var r = (d + Math.random() * 16) % 16 | 0;
    d = Math.floor(d / 16);
    return (c == "x" ? r : (r & 0x3) | 0x8).toString(36);
  });
  return uuid;
}

function getDeviceId() {
  let deviceId = localStorage.getItem("wework-device-id");
  if (!deviceId) {
    deviceId = generateUUID();
    localStorage.setItem("wework-device-id", deviceId);
  }
  return deviceId;
}

const isInWechatMP = () => {
  return (
    (navigator.userAgent.match(/micromessenger/i) &&
      navigator.userAgent.match(/miniprogram/i)) ||
    window.__wxjs_environment === "miniprogram"
  );
};

export function getSystemInfo() {
  const detected = new UA(window.navigator.userAgent);

  const systemInfo = {
    deviceId: null, // 设备id 未登录时用户唯一ID
    deviceType: null, // 设备类型 IOS，Android, PC
    sourceType: 1, // 来源类型 1 网页，2 小程序
    loadTime: null, //  1000ms 毫秒
  };

  systemInfo.deviceId = getDeviceId();

  if (detected.device.type === "desktop") {
    systemInfo.deviceType = "PC";
  } else {
    systemInfo.deviceType = detected.os.name;
  }
  if (isInWechatMP()) {
    systemInfo.sourceType = 2;
  }

  return systemInfo;
}

export function getOffice(hireLication) {
  if (
    [
      "上海",
      "北京",
      "西安",
      "苏州",
      "武汉",
      "杭州",
      "成都",
      "深圳",
      "广州",
      "南京",
    ].includes(hireLication)
  ) {
    return "中国大陆";
  }
  if (["香港"].includes(hireLication)) {
    return "香港";
  }
  if (["台北", "台湾"].includes(hireLication)) {
    return "台湾";
  }
}

export function baseInfoIsDone(userInfo) {
  const { hireLication, nationality, maritalStatus } = userInfo
  const office = getOffice(hireLication)

  const isDalu = nationality === "中国大陆";
  const isOfficeDalu = office === "中国大陆";
  const isOfficeHK = office === "香港";

  const baseProps = [
    'firstName',
    'lastName',
    'nickName',
    'sex',
    'dateOfBirth',
    'currentAddress',
    'maritalStatus',
    'nationality',

    'bankName',
    'bankBranch',
    'bankCardAccount',
    'accountName',

    'contactsName',
    'relationship',
    'contactPhone',

    'identificationNumber',
  ]

  if (isDalu && isOfficeDalu) {
    baseProps.push('politicalOutlook')
    baseProps.push('residentType')
    baseProps.push('residentLocation')
  }

  if (isOfficeDalu) {
    baseProps.push('isSocialSecurity')
  }

  if (isOfficeHK) {
    baseProps.push('bankCode')
    baseProps.push('passportIssueCountry')
    const married = ["已婚", "分居"].includes(maritalStatus);
    if (married) {
      baseProps.push('spousesName')
      baseProps.push('hongkongIdentityCard')
      baseProps.push('spousesPassportNumber')
      baseProps.push('spousesPassportIssueCountry')
    }
  }

  let flg = true;
  baseProps.forEach(key => {
    if (!userInfo[key]) {
      flg = false
    }
  })

  return flg
}
